import { withContext } from 'AppContext';
import LoadingSpinner from 'components/LoadingSpinner';
import moment from 'moment-timezone';
import React from 'react';
import { Query } from '@apollo/client/react/components'
import { withRouter } from 'react-router-dom';
import { ChartTableAll } from '../components/ChartTable';
import { make10minIntervalArray } from '../utils';
import { GetChartSamplesPerMeter, GetChartSamplesPerMeterVariables } from 'api/Sample/types/GetChartSamplesPerMeter';
import { GET_CHART_SAMPLES_PER_METER } from 'api/Sample';


@(withRouter as any)
@(withContext as any)
export default class AllMetersPage extends React.Component<any, any> {

  private timeStart: Date;
  private timeStamps: Date[];

  constructor(props: any) {
    super(props)
    this.state = {
      messages: []
    }
    this.timeStart = moment().subtract(1, 'day').toDate();
    this.timeStamps = make10minIntervalArray(this.timeStart);
    //DEBUG
//    this.timeStamps = make10minIntervalArray(moment('2020-01-12 17:25').toDate(), moment('2020-01-13 17:25').toDate());
  }

  componentDidMount() {
    const printMessage = msg => this.setState({ messages: [...this.state.messages, msg] });

  }


  render() {
    return (
      <div style={{paddingLeft: '0rem', overflowX: 'hidden', height: 'inherit'}}>
        <Query<GetChartSamplesPerMeter, GetChartSamplesPerMeterVariables>
          query                       = {GET_CHART_SAMPLES_PER_METER}
          notifyOnNetworkStatusChange = {true}
          variables                   = {{
            deviceIds: null,
            t0       : this.timeStart.toISOString(),
            t1       : moment().toISOString(),
          }}
          >
          {({networkStatus, data}) => {
            if (networkStatus <= 6) {
              //return <LoadingScreen visible={true} text={"Loading charts"}/>
              return <LoadingSpinner color={"var(--loadingSpinnerColor)"}/>
            }  
            return (
              <div style={{width: '100%', height: 'calc(100% - 5rem)'}}>
                {(networkStatus > 6) && data &&
                  <ChartTableAll
                    timestamps = {this.timeStamps}
                    dataset    = {data.chartSamplesPerMeter}
                    />
                }
              </div>
            )
        }}
        </Query>
      </div>
    )
  }

}
